<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-aside :width="width" style="padding:5px 0 0 10px;">
                <menu-tree :width="width" ref="menuTree" @selTree="selTree"></menu-tree>
            </el-aside>
            <div class="Ydriver"></div>
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <IconsDialog v-if="showIconDialog"
                     :formData="formData"
                     :loading="dialogLoading"
                     @closeDialog="closeDialog"
                     @selIcon="selIcon">
        </IconsDialog>
        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import menuTree from "@/components/system/menumanage/menuTree";
    import IconsDialog from "@/components/system/icon/IconsDialog";
    import editDialog from "@/components/system/menumanage/editDialog";

    export default {
        name: "menumanage",
        props: ['menuData'],
        components: {menuTree, tableGrid, IconsDialog, editDialog, toolBar},
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "菜单名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                width: "250px",

                showEditDialog: false,
                showIconDialog: false,
                dialogLoading: false,

                treeData: {
                    id: 0,
                    name: "菜单树"
                },
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "menuName", column_comment: "名称", column_width: "150"
                    },
                    {
                        column_name: "menuUrl", column_comment: "路径", column_width: "200"
                    },
                    {
                        column_name: "shiroKey", column_comment: "权限标识", column_width: "100"
                    },
                    {
                        column_name: "menuIcon",
                        column_comment: "图标",
                        column_width: "60",
                        type: 'custom',
                        render: this.headRender,
                    },
                    {
                        column_name: "menuOrder", column_comment: "顺序", column_width: "100", type: "hover"
                    },
                    {
                        column_name: "menuState", column_comment: "状态", column_width: "100", type: "tag",
                        info: [{code: '1', name: '启用', type: 'success'},
                            {code: '0', name: '未启用', type: 'danger'},]
                    },
                    {
                        column_name: "_opt", column_comment: "操作", column_width: "130", opts: [
                            {method: "icon", name: "图标", type: "info", icon: "el-icon-picture-outline"},
                        ]
                    },
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
            }
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/menu/list",
                    param: {
                        parentId: this.treeData.id,
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
            },

            closeDialog() {
                this.showEditDialog = false;
                this.showIconDialog = false;
            },
            async selIcon(icon) {
                this.dialogLoading = true;
                let param = {
                    menuId:this.formData.menuId,
                    menuIcon:icon,
                }
                const data = await this.$sqlOpt.save.save(param, "/menu/editIcon");
                if (data.infoCode === '0') {
                    await this.getListData();
                    this.$message({
                        type: 'success',
                        message: data.resultMsg
                    });
                }

                this.dialogLoading = false;
                this.showIconDialog = false;
            },
            headRender(h, data) {
                if (!data) return
                let component = []
                if (data) {
                    component = h('i', {
                        class: data.menuIcon,
                        style: {
                            "font-size": "30px"
                        }
                    })
                }
                return component
            },
            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;
                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.save(param, "/menu/save");
                if (data.infoCode === '0') {
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();
                    this.refreshTree();
                }
                this.dialogLoading = false;
                this.$refs.tableGrid.clearSelList();
            },
            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {
                    this.formData = {
                        parentId: this.treeData.id,
                        parentName: this.treeData.name,
                        state: 1
                    };
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }
                    if (type === "edit") {
                        this.showEditDialog = true;
                    }
                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/menu/delete",
                            param: {
                                menuId: this.formData.menuId,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.refresh);
                    }
                }
            },
            refresh() {
                this.getListData();
                this.refreshTree();
                this.$refs.tableGrid.clearSelList();
            },
            tableOpt(type, data) {
                if (type === "icon") {
                    this.formData = data;
                    this.showIconDialog = true;
                }
            },
            //点击左边表格
            selTree(data) {
                this.treeData = data;
                this.search();
                this.$refs.tableGrid.clearSelList();
            },
            //刷新左边表格
            refreshTree(key) {
                this.$refs.menuTree.refreshTree(key);
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
